import { Result, SessionProvider } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { Res } from 'core/api';
import { CashControl } from 'pos/services';
import { Message } from 'core/ui-next/modal';


declare global {
	interface CommandType {
		showCashControlStatus: () => Promise<Result>
	}
}

Command.register('showCashControlStatus', Preconditions.ensureSlaveCanHandleCashOperations, async (): Promise<Result> => {
	if (!SessionProvider.getCurrent().UseCashControl) {
		await Message.show(Res.Msg.MSG_CASH_CONTROL_NOT_AVAILABLE());
		return Result.error();
	}

	await CashControl.showOperations();

	return Result.ok();
});